import React from 'react';
import Schedule from './components/Schedule';
import './index.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Camp Régional des Jeunes et Evaluateurs Emergents Francophones</h1>
        <h2>8è Edition - 2 au 8 Novembre 2025</h2>
        <p>Dassa-Zoumé, Bénin</p>
        <p>Thème: Former pour le marché de l'évaluation : développer les compétences clés pour des écosystèmes d'évaluation performants dans l'espace francophone.</p>
      </header>
      <main>
        <Schedule />
      </main>
    </div>
  );
}

export default App;